import hyperform from "hyperform"
import maskInput from "vanilla-text-mask"
import { q } from "../../helper/q"

export const profileFormInit = () => {
  const form = q(".profileFormMain")
  if (form) {
    hyperform.setRenderer("attachWarning", function(warning, element) {
      element.parentNode.classList.add("floatInputError")
      element.parentNode.querySelector(".floatInputLabel").innerHTML = warning.innerHTML
    })

    if (form.querySelector("input[type='tel']")) {
      hyperform.addValidator(form.querySelector("input[type='tel']"), element => {
        const re = /^(\+7|7|8)?[\s/\\-]?\(?[0-9]{3}\)?[\s/\\-]?[0-9]{3}[\s/\\-]?[0-9]{2}[\s/\\-]?[0-9]{2}$/gm
        const valid = re.test(element.value)
        element.setCustomValidity(
          valid ? "" : element.value ? element.dataset.typeMismatch : element.dataset.valueMissing
        )
        return valid
      })
      maskInput({
        inputElement: form.querySelector("input[type='tel']"),
        mask: ["+", /[1-9]/, " ", "(", /[1-9]/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/],
        showMask: false,
        keepCharPositions: false
      })
    }

    hyperform(form)
  }
}
